import React from "react";
import { useNavigate } from "react-router-dom";
import FloatingButton from "../../components/FloatingButton";

function MyInvoices() {
  const navigate = useNavigate();
  return (
    <div>
      <h1>My Invoices</h1>
      <FloatingButton
        title="Add New Invoice"
        func={() => navigate("/invoices/create")}
      />
    </div>
  );
}

export default MyInvoices;
